import { render, staticRenderFns } from "./CustomSurveys.vue?vue&type=template&id=bf26e2c2&scoped=true&"
import script from "./CustomSurveys.vue?vue&type=script&lang=js&"
export * from "./CustomSurveys.vue?vue&type=script&lang=js&"
import style0 from "./CustomSurveys.vue?vue&type=style&index=0&id=bf26e2c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf26e2c2",
  null
  
)

export default component.exports